import React from 'react'
import './PanelContainer.scss'

const PanelContainer = (props) => {
  return <div className='a-panelContainer' {...props} />
}

export default PanelContainer
